import { render, staticRenderFns } from "./MediumEditor.vue?vue&type=template&id=05ba68d5&"
import script from "./MediumEditor.vue?vue&type=script&lang=js&"
export * from "./MediumEditor.vue?vue&type=script&lang=js&"
import style0 from "./MediumEditor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('05ba68d5', component.options)
    } else {
      api.reload('05ba68d5', component.options)
    }
    module.hot.accept("./MediumEditor.vue?vue&type=template&id=05ba68d5&", function () {
      api.rerender('05ba68d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/common/utils/components/MediumEditor.vue"
export default component.exports